import React, { type FC, useEffect } from "react";
import { useIntl } from "react-intl";
import {
  DataTable,
  SKELETON_LOADER_VARIANT_ONWHITE,
  SkeletonLoader,
  MessageBox,
} from "mailup-web-components";
import { useRecoilCallback, useRecoilValue } from "recoil";
import { importFilesPreviewCallback } from "Pages/ImportWizard/recoil/callbacks";
import { previewTableState } from "Pages/ImportWizard/recoil/state/stateStep2";
import { importFileWizardState } from "Pages/ImportWizard/recoil/state/state";
import styled from "@emotion/styled";

const TablePreview: FC = () => {
  const intl = useIntl();
  const { Rows, loading } = useRecoilValue(previewTableState);
  const { IgnoreFirstRow } = useRecoilValue(importFileWizardState);

  return (
    <StyledDataTable
      IgnoreFirstRow={IgnoreFirstRow}
      hScroll
      head={Rows[0].map(() => ({
        span: 1,
      }))}
      body={Rows.map((row: string[]) =>
        row.map((r: string) => ({
          content: loading ? (
            <SkeletonLoader variant={SKELETON_LOADER_VARIANT_ONWHITE} />
          ) : (
            r
          ),
        })),
      )}
    />
  );
};
export default TablePreview;

const StyledDataTable = styled(DataTable)`
  tbody tr:first-child td{
    background-color: ${(props: { IgnoreFirstRow: boolean }) => (props.IgnoreFirstRow ? "#EEEEEE" : "white")};
    
    &:hover {
      background-color: ${(props: { IgnoreFirstRow: boolean }) => (props.IgnoreFirstRow ? "#EEEEEE" : "white")};
    }
  }

  tbody tr:not(:first-child) td {
    background-color: white;
    
    &:hover {
      background-color: white;
    }
  }

`;
